export const DELAY_MULTIPLIER = 100;
export const DELAY_INITIAL = 0;
export enum DELAY_TYPES {
  TITLE = 1100,
  MAX = 500,
  MEDIUM = 300,
  MIN = 100,
  NONE = 0
}
